import projectData from './project-data';

/* eslint-disable import/no-unresolved */
import popWav from '!file-loader!./83a9787d4cb6f3b7632b4ddfebf74367.wav';
import meowWav from '!file-loader!./83c36d806dc92327b9e7049a565c6bff.wav';
import backdrop from '!file-loader!./cd21514d0531fdffb22204e0ec5ed84a.svg';
import costume1 from '!file-loader!./09dc888b0b7df19f70d81588ae73420e.svg';
import costume2 from '!file-loader!./3696356a03a8d938318876a593572843.svg';
import blank from '!file-loader!./8e15625d6c158ec48f374efb77bd2714.svg';
/* eslint-enable import/no-unresolved */

const fetchBlob = (url) => {
    return fetch(url).then(response => response.blob())
}

const defaultProject = translator => {
    const projectJson = projectData(translator);
    return Promise.all([
        fetchBlob(popWav),
        fetchBlob(meowWav),
        fetchBlob(backdrop),
        fetchBlob(costume1),
        fetchBlob(costume2),
        fetchBlob(blank)
    ]).then(([popWav, meowWav, backdrop, costume1, costume2, blank]) => [{
        id: 0,
        assetType: 'Project',
        dataFormat: 'JSON',
        data: JSON.stringify(projectJson)
    }, {
        id: '83a9787d4cb6f3b7632b4ddfebf74367',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: popWav
    }, {
        id: '83c36d806dc92327b9e7049a565c6bff',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: meowWav
    }, {
        id: 'cd21514d0531fdffb22204e0ec5ed84a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: backdrop
    }, {
        id: '09dc888b0b7df19f70d81588ae73420e',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: costume1
    }, {
        id: '3696356a03a8d938318876a593572843',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: costume2
    }, {
        id: '8e15625d6c158ec48f374efb77bd2714',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: blank
    }])
};
export default defaultProject;
